__turbopack_context__.v({
  "accountCreatedContainer": "styles-module__sVJGMG__accountCreatedContainer",
  "codeSentMessage": "styles-module__sVJGMG__codeSentMessage",
  "enterTheNumberDescription": "styles-module__sVJGMG__enterTheNumberDescription",
  "formError": "styles-module__sVJGMG__formError",
  "gradientBackground": "styles-module__sVJGMG__gradientBackground",
  "heading": "styles-module__sVJGMG__heading",
  "helpNeededContainer": "styles-module__sVJGMG__helpNeededContainer",
  "inputErrorStyling": "styles-module__sVJGMG__inputErrorStyling",
  "inputStyling": "styles-module__sVJGMG__inputStyling",
  "mobileHide": "styles-module__sVJGMG__mobileHide",
  "passwordErrorItem": "styles-module__sVJGMG__passwordErrorItem",
  "passwordErrorNeedsFixing": "styles-module__sVJGMG__passwordErrorNeedsFixing",
  "resendCodeContainer": "styles-module__sVJGMG__resendCodeContainer",
  "serefinContainer": "styles-module__sVJGMG__serefinContainer",
  "signUpContainer": "styles-module__sVJGMG__signUpContainer",
  "textButton": "styles-module__sVJGMG__textButton",
});
